<template>
    <div class="body-bg">
        <div class="-default"></div>
        <div class="-mario"></div>
        <div class="-admin"></div>
        <div class="-confianca"></div>
        <div class="-desbravando">
            <!-- <img src="../assets/img/Logo8i3.png" class="bg-logo">
            <div class="bg-des3"></div> -->
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BgBody'
    }
</script>